import React, { useState, useEffect, useRef } from 'react';

// Common Google Apps Script URL for sending email and saving to sheet
const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzarPrFP5bxRAWt9bKseenOljffX_QqWoS0IR39yVnlgy6_gNSdfLGWtYHnPwKR_td3gw/exec";

const ContactSection = ({openModal}) => {
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedCompanySize, setSelectedCompanySize] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const sliderRef = useRef(null);
  const animationRef = useRef(null);

  // Topics data
  const topics = [
    {
      id: 1,
      title: 'Cloud Infrastructure & Migration',
      description: 'Cloud deployment, infrastructure modernization, workload migration, and managed hosting services.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
        </svg>
      )
    },
    {
      id: 2,
      title: 'Web & Application Development',
      description: 'Custom websites, web applications, APIs, and business software built with modern technologies.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
        </svg>
      )
    },
    {
      id: 3,
      title: 'AI, Automation & Data Solutions',
      description: 'AI-powered applications, workflow automation, data processing, and intelligent business solutions.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
      )
    },
    {
      id: 4,
      title: 'Cybersecurity & Access Management',
      description: 'Infrastructure security, identity management, data protection, backups, and compliance solutions.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
        </svg>
      )
    },
    {
      id: 6,
      title: 'Technology Consulting & Planning',
      description: 'Strategic guidance for infrastructure, cloud adoption, digital transformation, and IT operations.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
        </svg>
      )
    },
    {
      id: 7,
      title: 'Something else',
      description: "Have a unique project or requirement? Tell us what you need and we'll explore the best solution together.",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
        </svg>
      ),
      fullWidth: true
    }
  ];

 // Organization size options
const companySizes = [
  {
    id: 'individual',
    label: 'Independent Professional',
    emoji: '💼'
  },
  {
    id: 'startup',
    label: 'Growing Business (2-10 Team Members)',
    emoji: '📈'
  },
  {
    id: 'sme',
    label: 'Small Business (11-50 Team Members)',
    emoji: '🏬'
  },
  {
    id: 'midmarket',
    label: 'Medium Business (51-250 Team Members)',
    emoji: '🏗️'
  },
  {
    id: 'enterprise',
    label: 'Large Enterprise (250+ Team Members)',
    emoji: '🏙️'
  }
];

  



  // Auto-scroll animation for logos
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let scrollPosition = 0;
    const speed = 0.5;

    const getSetWidth = () => {
      const firstSet = slider.children[0];
      return firstSet ? firstSet.offsetWidth / 3 : 0;
    };

    const animate = () => {
      if (!isHovered) {
        scrollPosition -= speed;
        const setWidth = getSetWidth();
        
        if (Math.abs(scrollPosition) >= setWidth) {
          scrollPosition = 0;
        }
        
        if (slider) {
          slider.style.transform = `translate3d(${scrollPosition}px, 0px, 0px)`;
        }
      }
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isHovered]);

  const handleTopicSelect = (topicId) => {
    let updatedTopics;
    if (selectedTopics.includes(topicId)) {
      updatedTopics = selectedTopics.filter(id => id !== topicId);
    } else {
      updatedTopics = [...selectedTopics, topicId];
    }
    setSelectedTopics(updatedTopics);

    // Log selected topics with their actual titles
    const selectedNames = updatedTopics.map(id => topics.find(t => t.id === id)?.title || id);
    console.log("Selected Topics:", selectedNames);
  };

  const handleCompanySizeSelect = (sizeId) => {
    setSelectedCompanySize(sizeId);
    // Log selected company size with its label
    const sizeName = companySizes.find(c => c.id === sizeId)?.label || sizeId;
    console.log("Selected Company Size:", sizeName);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [id]: value };
      // Log input change dynamically
      console.log(`Form Input Changed - ${id}:`, value);
      return updated;
    });
  };

  const handleNextStep = () => {
    if (currentStep === 1 && selectedTopics.length > 0) {
      setCurrentStep(2);
    } else if (currentStep === 2 && selectedCompanySize) {
      setCurrentStep(3);
    }
  };

  const handlePreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.name || !formData.email) {
      alert('Please fill in all required fields');
      return;
    }

    setIsSubmitting(true);

    // Prepare unified payload for Google Apps Script
    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone || '',
      company: '', // Empty for this form
      service: selectedTopics.map(id => topics.find(t => t.id === id)?.title || id).join(', '),
      companySize: companySizes.find(c => c.id === selectedCompanySize)?.label || selectedCompanySize || '',
      comments: formData.message || '',
      source: 'Contact Section (Multi-step Form)'
    };

    console.log('Form Submitted (Sending to Apps Script):', payload);

    try {
      const response = await fetch(APPS_SCRIPT_URL, {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      if (response.status === 200 || response.ok) {
        // Show thank you message
        setShowThankYou(true);
        
        // Reset form after 2 seconds and go back to step 1
        setTimeout(() => {
          setSelectedTopics([]);
          setSelectedCompanySize(null);
          setFormData({ name: '', email: '', phone: '', message: '' });
          setCurrentStep(1);
          setShowThankYou(false);
          setIsSubmitting(false);
        }, 2000);
      } else {
        throw new Error(`Server responded with status: ${response.status}`);
      }
      
    } catch (error) {
      console.error('Submission error:', error);
      alert('Something went wrong. Please try again.');
      setIsSubmitting(false);
    }
  };

  const getProgressPercentage = () => {
    return (currentStep / 3) * 100;
  };

  // Mail Icon
  const MailIcon = () => (
    <svg className="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  );

  // Calendar Icon
  const CalendarIcon = () => (
    <svg className="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  );

  // Arrow Icon
  const ArrowIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
    </svg>
  );

  // Back Arrow Icon
  const BackArrowIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
    </svg>
  );

  // Render Step 1: Topic Selection
  const renderStep1 = () => (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-white mb-2">What can we help you with?</h3>
        <p className="text-gray-400">Choose one or more services that match your project requirements.</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {topics.map((topic) => (
          <button
            key={topic.id}
            type="button"
            onClick={() => handleTopicSelect(topic.id)}
            className={`relative p-5 rounded-xl border transition-all duration-300 text-left group hover:scale-[1.02] hover:shadow-lg bg-gray-800/50 border-gray-700 hover:border-gray-600
              ${selectedTopics.includes(topic.id) ? 'bg-gradient-to-r from-blue-300 to-green-200 shadow-lg' : ''}
              ${topic.fullWidth ? '' : ''}`}
          >
            <div className={`absolute top-3 right-3 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${selectedTopics.includes(topic.id) ? 'border-gray-800' : 'border-gray-600 group-hover:border-gray-500'}`}>
              {selectedTopics.includes(topic.id) && (
                <svg className="w-4 h-4 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
            <div className="flex items-start gap-4 pr-8">
              <div className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center transition-colors duration-300 bg-gray-700/50
                ${selectedTopics.includes(topic.id) ? 'bg-[#E75301]/10' : ''}`}>
                {React.cloneElement(topic.icon, {
                  className: `w-6 h-6 ${selectedTopics.includes(topic.id) ? 'text-green-600' : 'text-gray-400'}`,
                })}
              </div>
              <div className="flex-1">
                <h4 className={`font-semibold ${selectedTopics.includes(topic.id) ? 'text-green-800' : 'text-white'} mb-1 group-hover:text-green-600 transition-colors`}>
                  {topic.title}
                </h4>
                <p className={`text-sm ${selectedTopics.includes(topic.id) ? 'text-gray-800' : 'text-gray-400'}`}>
                  {topic.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );

  // Render Step 2: Company Size
  const renderStep2 = () => (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-white mb-2">How large is your company?</h3>
        <p className="text-gray-400">So we can put together the right solution for you</p>
      </div>
      
      <div className="space-y-3 max-w-2xl mx-auto">
        {companySizes.map((size) => (
          <button
            key={size.id}
            type="button"
            onClick={() => handleCompanySizeSelect(size.id)}
            className={`w-full p-4 rounded-xl border-2 transition-all duration-300 text-left flex items-center gap-4 hover:scale-[1.01]
              ${selectedCompanySize === size.id 
                ? ' border-blue-600 shadow-lg shadow-blue-300/30' 
                : 'bg-gray-800/50 border-gray-700 hover:border-blue-600 hover:bg-gray-800/70'}`}
          >
            <span className="text-3xl">{size.emoji}</span>
            <span className={`flex-1 font-medium ${selectedCompanySize === size.id ? 'text-white' : 'text-white'}`}>
              {size.label}
            </span>
            {selectedCompanySize === size.id && (
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );

  // Render Step 3: Contact Form
  const renderStep3 = () => (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-white mb-2">Almost there!</h3>
        <p className="text-gray-400">How can we best reach you?</p>
      </div>
      
      <div className="space-y-4 max-w-2xl mx-auto">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            value={formData.name}
            onChange={handleInputChange}
            className="w-full px-4 py-3 rounded-lg bg-gray-700/50 backdrop-blur-sm border border-gray-600 text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/20 transition-all"
            placeholder="John Doe"
          />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={formData.email}
              onChange={handleInputChange}
              className="w-full px-4 py-3 rounded-lg bg-gray-700/50 backdrop-blur-sm border border-gray-600 text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/20 transition-all"
              placeholder="john@example.com"
            />
          </div>
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2">Phone (optional)</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              className="w-full px-4 py-3 rounded-lg bg-gray-700/50 backdrop-blur-sm border border-gray-600 text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/20 transition-all"
              placeholder="+49 123 456789"
            />
          </div>
        </div>
        
        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2">Message (optional)</label>
          <textarea
            id="message"
            name="message"
            rows="4"
            value={formData.message}
            onChange={handleInputChange}
            className="w-full px-4 py-3 rounded-lg bg-gray-800/50 backdrop-blur-sm border border-gray-600 text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/20 transition-all resize-none"
            placeholder="Any additional details?"
          />
        </div>
      </div>
    </div>
  );

  // Render Thank You Message
  if (showThankYou) {
    return (
      <section className="py-16 md:py-20 bg-gray-900 text-white relative overflow-hidden" id="contact">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#e75301] rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-pulse"></div>
        </div>
        <div className="max-w-[1140px] mx-auto px-4 relative z-10">
          <div className="max-w-2xl mx-auto text-center">
            <div className="bg-gray-800/30 backdrop-blur-sm rounded-2xl p-12 border border-gray-700/50">
              <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">Thank You for Your Request!</h3>
              <p className="text-gray-400">We've received your inquiry and will get back to you within 24 hours.</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (<>
    <section className="py-8 md:py-10 bg-gray-900 text-white relative overflow-hidden" id="contact">
    

      {/* Background Effects */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#e75301] rounded-full filter blur-3xl animate-pulse" style={{ animationDuration: '8s' }}></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-pulse" style={{ animationDuration: '10s', animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-[1140px] mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-center mb-16">
          {/* Left Side - Contact Info */}
          <div className="lg:col-span-3 space-y-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">Let's Discuss Your Project</h2>
              <div className="w-16 h-1 bg-green-600"></div>
            </div>
            <p className="text-base text-gray-300">
              Whether you're planning a new solution, upgrading existing systems, or exploring new opportunities, we're here to help. In a short consultation, we'll understand your requirements and discuss how AyanshTech Solutions can support your goals.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a href="mailto:info@ayanshtechnology.com" className="group flex items-center gap-3 px-5 py-3 bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl hover:bg-gray-800/70 hover:border-blue-600 transition-all duration-300">
                <div className="w-10 h-10 bg-gray-500 rounded-lg flex items-center justify-center transition-colors">
                  <MailIcon />
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-400">E-Mail</div>
                  <div className="text-sm font-medium text-white">info@ayanshtechnology.com</div>
                </div>
              </a>
              <button onClick={openModal} className="group flex items-center gap-3 px-5 py-3 backdrop-blur-sm border border-blue-600 rounded-xl hover:border-blue-600 transition-all duration-300 cursor-pointer">
                <div className="w-10 h-10 bg-gray-500 rounded-lg flex items-center justify-center transition-colors">
                  <CalendarIcon />
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-400">Schedule</div>
                  <div className="text-sm font-medium text-white">Schedule a Call</div>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="max-w-4xl mx-auto">
          <div className="mb-6">
            <div className="mb-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-gray-400">
                  {currentStep}/3 – {currentStep === 1 ? 'Topic Selection' : currentStep === 2 ? 'Company Size' : 'Contact Details'}
                </span>
                <span className="text-sm text-gray-400">{Math.round(getProgressPercentage())}%</span>
              </div>
              <div className="w-full h-2 bg-gray-800 rounded-full overflow-hidden">
                <div 
                  className="h-full bg-gradient-to-r from-blue-600 to-green-500 transition-all duration-500 ease-out" 
                  style={{ width: `${getProgressPercentage()}%` }}
                ></div>
              </div>
            </div>
          </div>

          <div className="relative">
            <form onSubmit={handleSubmit} className="max-w-4xl mx-auto bg-gray-800/30 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-blue-500 shadow-blue-600">
              <div className="min-h-[400px]">
                {currentStep === 1 && renderStep1()}
                {currentStep === 2 && renderStep2()}
                {currentStep === 3 && renderStep3()}
              </div>
              
              <div className="flex items-center justify-between pt-8 mt-8 border-t border-gray-700">
                <button 
                  type="button" 
                  onClick={handlePreviousStep}
                  className={`flex items-center gap-2 px-5 py-3 transition-colors ${currentStep > 1 ? 'text-gray-300 hover:text-white' : 'text-gray-600 cursor-not-allowed'}`}
                  disabled={currentStep === 1}
                >
                  <BackArrowIcon />
                  Back
                </button>
                
                <div className="flex items-center gap-4">
                  {currentStep === 1 && (
                    <button 
                      type="button" 
                      onClick={() => setCurrentStep(3)}
                      className="text-green-600 hover:text-green-700 text-sm font-medium underline transition-colors"
                    >
                      Just leave your email →
                    </button>
                  )}
                  
                  {currentStep < 3 && (
                    <button 
                      type="button" 
                      onClick={handleNextStep}
                      disabled={(currentStep === 1 && selectedTopics.length === 0) || (currentStep === 2 && !selectedCompanySize)}
                      className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                        ((currentStep === 1 && selectedTopics.length > 0) || (currentStep === 2 && selectedCompanySize))
                          ? 'bg-gradient-to-r from-blue-600 to-green-500 hover:bg-[#ad3a00] text-white cursor-pointer'
                          : 'bg-gray-700 text-gray-400 cursor-not-allowed opacity-50'
                      }`}
                    >
                      Continue
                      <ArrowIcon />
                    </button>
                  )}
                  
                  {currentStep === 3 && (
                    <button 
                      type="submit"
                      disabled={isSubmitting || !formData.name || !formData.email}
                      className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                        !isSubmitting && formData.name && formData.email
                          ? 'bg-gradient-to-r from-blue-600 to-green-500 hover:bg-[#ad3a00] text-white cursor-pointer shadow-lg shadow-[#E75301]/25'
                          : 'bg-gray-700 text-gray-400 cursor-not-allowed opacity-50'
                      }`}
                    >
                      {isSubmitting ? 'Submitting...' : 'Submit Request'}
                      {!isSubmitting && <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>}
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    </>);
};

export default ContactSection;